import globalCourseCalendarStore from '../../../../../../stores/global-course-calendar';
import React from 'react';

export const CalendarDisplayWeekDaysToolbar = () => {
  const getDay = (dayStr: string) => (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {dayStr}
    </div>
  );
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        visibility:
          globalCourseCalendarStore.displayView === 'week'
            ? 'visible'
            : 'hidden',
      }}
    >
      <div style={{ minWidth: '80px' }} />
      {getDay('א׳')}
      {getDay('ב׳')}
      {getDay('ג׳')}
      {getDay('ד׳')}
      {getDay('ה׳')}
      {getDay('ו׳')}
      {getDay('ש׳')}
    </div>
  );
};
